// Core modules imports are same as usual
import { Pagination, Autoplay } from 'swiper';
// Direct React component imports
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
// import { isLocaleEnglish } from 'utils/languageUtils';
// import { useTranslation } from 'react-i18next';
import { Swiper as SwiperCore } from 'swiper';
// Styles must use direct files imports
import 'swiper/swiper.less'; // core Swiper
import 'swiper/modules/navigation/navigation.less'; // Navigation module
import 'swiper/modules/pagination/pagination.less'; // Pagination module
import './BannerCarousel.less';
import { NewsProps } from 'utils/liHome';
import { default as NewsCard } from './NewsSection';
import { useEffect, useRef } from 'react';
type SwiperPageProps = {
  news?: NewsProps[];
  num?: number;
};
const SwiperPage = ({ news, num }: SwiperPageProps) => {
  // const { i18n } = useTranslation();
  const swiperRef = useRef<SwiperCore>();
  // const isEnglish = isLocaleEnglish(i18n.language);
  useEffect(() => {
    if (swiperRef.current && num != undefined) {
      swiperRef.current.slideTo(num ?? 0); // 跳转到第三个slide
    }
  }, [num]);
  return (
    <div style={{ width: '91.53%', height: '306px', margin: 'auto', marginTop: '13px' }}>
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        loop={true} //设置循环轮播
        className="mySwiper"
        spaceBetween={20} //设置堆叠轮播，item之间叠的距离
        slidesPerView="auto" //设置显示的数量
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        grabCursor={true}
        centeredSlides={false} // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
        slideToClickedSlide={false} // 点击的slide会居中
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        }}
      >
        {news?.map((item, index) => {
          return (
            <SwiperSlide key={index} style={{ maxWidth: 293 }}>
              <div className="swiper-img-ca" style={{ width: '100%', height: '100%' }}>
                <div className="image-new-ca">
                  <img src={item.imgSrc} alt="" />
                </div>
                <div className="desc-right">
                  <div className="wraper">
                    <p className="title-date">
                      <span className="title">{item.title}</span>
                      {/* <span className="date">{item.publishTime}</span> */}
                    </p>
                    <p className="desc">{item.description}</p>
                  </div>
                  <NewsCard url={item.url} />
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
export default SwiperPage;
